/** @packageDocumentation @internalapi @module vanilla */
export * from './vanilla/index';
//# sourceMappingURL=vanilla.js.map


//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/@uirouter/core/lib-esm/vanilla.js
// module id = 163
// module chunks = 0